var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHatIconOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9306 3.12914C11.6149 2.95695 11.2334 2.95695 10.9177 3.12914L2.55116 7.69271C1.81613 8.09364 1.81632 9.14913 2.55148 9.54979L4.69406 10.7175V15.8585C4.69406 16.2454 4.90537 16.6015 5.24503 16.7868L10.9175 19.8824C11.2333 20.0547 11.615 20.0547 11.9308 19.8824L17.6033 16.7868C17.9429 16.6015 18.1542 16.2454 18.1542 15.8585V10.7175L20.0771 9.66952V15.3516C20.0771 15.8826 20.5076 16.3131 21.0386 16.3131C21.5695 16.3131 22 15.8826 22 15.3516V9.24937C22 8.86235 21.7886 8.50624 21.4488 8.32092L11.9306 3.12914ZM16.2314 15.342L11.4241 17.9668L6.61694 15.342V11.7655L11.4241 14.3902L16.2314 11.7655V15.342ZM11.4241 12.1981L4.86712 8.62155L11.4241 5.04499L17.9812 8.62155L11.4241 12.1981Z",
    fill: "#82AABE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatIconOff);
export default __webpack_public_path__ + "static/media/hatIconOff.e808c432ddf4565e75416fd4dd399452.svg";
export { ForwardRef as ReactComponent };